export interface IAtividadeSequencial {
    AtividadeNo: number;
    TarefaNo: number;
    AtividadeNome: string;
}
